export const Events = {
    displayProfile: 'displayProfile'
}